'use strict';

(function() {
  angular
    .module('specsguardApp')
    .directive('widgetProjectAssignedElements', widgetProjectAssignedElements);

  function widgetProjectAssignedElements () {
    return {
      restrict: 'E',
      templateUrl: 'app-legacy/project/overview/widgets/assigned-elements/widget-project-assigned-elements.tmpl.html',
      controller: 'widgetProjectAssignedElementsCtrl',
      controllerAs: '$widgetProjectAssignedElementsCtrl',
      scope: true,
      require: '^sgWidgetsCtrl'
    };
  }
})();
